import { makeNumbersFarsi } from '../../utils/farsi'
import { useFetchCities } from '../../hooks/useFetchIranCities'
import { useFetchProvinces } from '../../hooks/useFetchProvinces'

export const ReceiverInfo = ({ order }: any) => {
  const { cities } = useFetchCities()
  const { provinces } = useFetchProvinces()
  const city = cities?.find((city) => city.id === order.shippingAddressCityId)
  let ProvinceTitle = provinces?.find(
    (province) => province.id === city?.provinceId,
  )?.title

  return (
    <div className='w-full my-8'>
      <div className='my-1'>
        <strong>آدرس گیرنده: </strong>
        <span className='text-lg font-medium'>استان {ProvinceTitle}، </span>
        <span className='text-lg font-medium'>شهر {city?.title}، </span>
        <span className='text-lg font-medium'>
          {makeNumbersFarsi(order.shippingAddressText)}{' '}
        </span>

        {order.shippingAddressPostalCode && (
          <span className='text-lg font-medium'>
            ، کد پستی {makeNumbersFarsi(order.shippingAddressPostalCode)}
          </span>
        )}
      </div>

      <div className='my-1'>
        <strong>نام گیرنده: </strong>
        <span className='text-lg font-medium'>
          {order.receiverFirstName} {order.receiverLastName}
        </span>
      </div>

      <div className='my-1'>
        <strong>شماره تماس گیرنده: </strong>
        <span className='text-lg font-medium'>
          {makeNumbersFarsi(order.receiverTelephone)}
        </span>
      </div>
    </div>
  )
}
